import { Box, Button, Grid, LinearProgress } from '@material-ui/core';
import { createTheme, lighten, makeStyles, withStyles } from '@material-ui/core/styles';
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import CloseIcon from '@mui/icons-material/Close';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import Checkbox from '@mui/material/Checkbox';
import CircularProgress from '@mui/material/CircularProgress';
import { green } from '@mui/material/colors';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import Slide from '@mui/material/Slide';
import Snackbar from '@mui/material/Snackbar';
import Stack from '@mui/material/Stack';
import { useTheme } from '@mui/material/styles';
import TableFooter from '@mui/material/TableFooter';
import TablePagination from '@mui/material/TablePagination';
import { TransitionProps } from '@mui/material/transitions';
import axios from "axios";
import { Localization } from "material-table";
import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import 'whatwg-fetch';
import { API_URL } from "../../Const";
import GenericTemplate from "../templates/GenericTemplate";
import './style.css';
import { useLoadingOverlay } from '../../utilHooks/loadingOverlay';


const theme = createTheme({
  /*
  palette: {
    secondary: {
      main: "rgba(33, 150, 243, 1) !important",
    },
  },
  */
  overrides: {
    MuiTableRow: {
      hover: {
        "&:hover": {
          backgroundColor: "rgba(33, 150, 243, 0.25) !important"
        }
      }
    }
  }
});

const localizationJapanese: Localization = {
  error: "エラー",
  body: {
    emptyDataSourceMessage: "表示するレコードがありません。",
    filterRow: {
      filterTooltip: "フィルター",
    },
  },
  header: {
    actions: "アクション",
  },
  grouping: {
    groupedBy: "グループ化:",
    placeholder: "ヘッダーをドラッグ ...",
  },
  pagination: {
    firstTooltip: "最初のページ",
    firstAriaLabel: "最初のページ",
    previousTooltip: "前のページ",
    previousAriaLabel: "前のページ",
    nextTooltip: "次のページ",
    nextAriaLabel: "次のページ",
    labelDisplayedRows: "{from}-{to} 全{count}件",
    labelRowsPerPage: "ページあたりの行数:",
    lastTooltip: "最後のページ",
    lastAriaLabel: "最後のページ",
    labelRowsSelect: "行",
  },
  toolbar: {
    nRowsSelected: "{0} 行選択",
  },
};

/* CSS */
const BorderLinearProgress = withStyles({
  root: {
    height: 30,
    width: 130,
    backgroundColor: lighten('#0000FF', 0.9),
  },
  bar: {
    backgroundColor: '#0000FF',
  },
})(LinearProgress);

const useStyles = makeStyles({
  table: {
    minWidth: 650,
  },
  root: {
    flexGrow: 1,
  },
  margin: {
    margin: 10,
  },
});

/* ダイアログ関連*/
const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />;
});
/*ダイアログ関連*/

/*ページネーション*/
interface TablePaginationActionsProps {
  count: number;
  page: number;
  rowsPerPage: number;
  onPageChange: (
    event: React.MouseEvent<HTMLButtonElement>,
    newPage: number,
  ) => void;
}

function TablePaginationActions(props: TablePaginationActionsProps) {

  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (
    event: React.MouseEvent<HTMLButtonElement>,
  ) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
}
/*ページネーション*/

// 画面表示
const Constructionlist: React.FC = () => {
  const { openLoading, closeLoading } = useLoadingOverlay()
  /*スピナー処理*/
  const [loading, setLoading] = React.useState(2);
  const [success, setSuccess] = React.useState(false);
  /*スピナー処理*/

  /*ダイアログ処理*/
  const [open, setOpen] = React.useState(false);
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  /*ダイアログ処理*/


  const label = { inputProps: { 'aria-label': 'Checkbox user' } };
  const [postslist, setPostsList] = useState<any[]>([])
  const [disprows, setDispRows] = useState<any[]>([])
  const [checkedItems, setCheckedItems] = useState({})
  const [checkedItems2, setCheckedItems2] = useState({})
  const [checkedStatus, setCheckedStatus] = React.useState(true)
  const [checkedStatus2, setCheckedStatus2] = React.useState(true)
  let jsonlist = JSON.parse(localStorage.getItem("datalist") || '{}')
  /*id取得*/
  const { state } = useLocation();
  const conid = (state as any)?.conid;
  //console.log(conid)

  useEffect(() => {
    openLoading()
    axios.post(API_URL.CONSTRUCTION_GET,
      {
        // /*
        // "construction_id": conid,
        // "company_id":"sampleCompany1",
        // "dealer_info_id": "sampleCompany1"
        // */

        "construction_id": conid,
        "company_id": jsonlist.user.company_id,
        "dealer_info_id": jsonlist.user.dealer_info_id

      },
      { headers: { Authorization: jsonlist.token.IdToken } },
    )
      .then(res => {
        const persons = res.data.data;
        const inslist = res.data.data.inspection_info;
        console.log(inslist)
        console.log(persons)
        setPostsList(inslist)
      })
      .catch(error => {
        //let jsonObject = JSON.parse(error);
        console.log(error)
      })
      .finally(() => {
        closeLoading()
      })
  }, []);

  useEffect(() => {
    /*配列データ*/
    const rows: any = [];
    postslist.map((item) => {
      const witness = item.witness.length > 0 ? item.witness[0].name : ""
      rows.push({ created_at: item.created_at, inspection_info_id: item.inspection_info_id, inspection_work_type: item.inspection_work_type, inspection_kind: item.inspection_kind, remarks: item.remarks, witness: witness, common_number: item.common_number })
    })
    console.log(rows)
    setDispRows(rows)
  }, [postslist])

  /*ページネーション*/
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);

  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - postslist.length) : 0;

  const handleChangePage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number,
  ) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  /*ページネーション*/

  //チェックボックスクリック
  const clickCheck = (e: any) => {
    setCheckedItems({
      ...checkedItems,
      [e.target.id]: e.target.checked
    })
    setCheckedStatus(getChecked)
  }


  //チェックボックスクリック
  const clickCheck2 = (e: any) => {
    if (loading == 2) {
      setLoading(1)
    }
    setCheckedItems2({
      ...checkedItems2,
      [e.target.id]: e.target.checked
    })
    setCheckedStatus2(getChecked2)
  }

  //console.log((checkedItems2 as any)?.movie)
  //console.log((checkedItems2 as any)?.img)
  //console.log((checkedItems2 as any)?.csv)
  if (loading == 1) {
    if (!(checkedItems2 as any)?.movie && !(checkedItems2 as any)?.img && !(checkedItems2 as any)?.csv) {
      setLoading(2);
    }
  }

  // チェックボックスのチェック状態取得用
  let getCheckedItems = (user_id: string) => {
    let ret = JSON.parse('false')
    for (let [key, value] of Object.entries(checkedItems)) {
      if (user_id == key) {
        return value
      }
    }
    return ret
  }

  // チェックボックスのチェック状態取得用
  let getCheckedItems2 = (user_id: string) => {
    let ret = JSON.parse('false')
    for (let [key, value] of Object.entries(checkedItems2)) {
      if (user_id == key) {
        return value
      }
    }
    return ret
  }



  // 削除ボタン押下
  const DelCheckSubmit = (e: any) => {
    // const test = getChecked()
    // console.log('getChecked',test)
    // if (len(getChecked) == 0) {

    // }
    const test = getChecked()
    if (getChecked()) {
      toastOpen()
      return
    }

    /*
    const ids_param = []
    for (let [key, value] of Object.entries(checkedItems)) {
      if (value) {
        ids_param.push(key)
        console.log(ids_param.push(key))
        console.log(value)
      }
    }
*/
    //  console.log(ids_param)
    //console.log('削除ボタンモード＝', test)
    //console.log('del:', checkedItems)
    handleClickOpen();
  }

  // チェック状態取得
  const getChecked = () => {
    //console.log("checkedItems",checkedItems)
    let ret = JSON.parse('true')
    for (let [key, value] of Object.entries(checkedItems)) {
      if (value == true) {
        //console.log('getChecked_a:',false)
        return JSON.parse('false')
      }
      // console.log('getChecked:false',key,value)
    }
    //console.log('getChecked_b:',ret)
    return ret
  }

  // チェック状態取得
  const getChecked2 = () => {
    let ret = JSON.parse('true')
    for (let [key, value] of Object.entries(checkedItems2)) {
      if (value == true) {
        return JSON.parse('false')
      }
    }
    return ret
  }



  // 削除処理
  const clickSubmit = (e: any) => {
    /*スピナー*/
    if (loading == 1) {
      setSuccess(false);
      setLoading(0);
    }
    /*スピナー*/

    // 削除対象の設定
    const ids_param = []
    for (let [key, value] of Object.entries(checkedItems)) {
      if (value) {
        ids_param.push(key)
      }
    }
    // 削除対象の設定
    const output_param = []
    for (let [key, value] of Object.entries(checkedItems2)) {
      if (value) {
        output_param.push(value)
      }
    }
    // 削除対象の設定
    const output_param2 = []
    for (let [key, value] of Object.entries(checkedItems2)) {
      if (value) {
        output_param2.push(value)
      }
    }

    let movie_no;
    let img_no;
    let csv_no;
    // POST処理　削除
    console.log(ids_param)
    if ((checkedItems2 as any)?.movie) {
      movie_no = "1"
    } else {
      movie_no = "0"
    }
    if ((checkedItems2 as any)?.img) {
      img_no = "1"
    } else {
      img_no = "0"
    }
    if ((checkedItems2 as any)?.csv) {
      csv_no = "1"
    } else {
      csv_no = "0"
    }

    openLoading()
    axios.post(API_URL.FILE_DOWNLOAD,
      {
        /*
  "company_id": "sampleCompany10",
  "dealer_info_id": "sampleCompany10",
  "construction_id": "dokodemokun_fc847e0b_bc80_4793_aa41_9b4c5902ce64",
  "inspection_info_id": [
    "inspection_13ae54a3_4349_47a0_a1bb_59fe3c15cecb",
    "inspection_10598583_4f3f_477a_b7b1_f69f2b980366",
    "inspection_e68ca5e4_fa36_4820_9d12_d95d08bb0546"
  ],
  "type_screenshot": "1",
  "type_clip": "1",
  "type_checklist": "1"
        */
        "company_id": jsonlist.user.company_id,
        "dealer_info_id": jsonlist.user.company_id,
        "construction_id": conid,
        "inspection_info_id": ids_param,
        "type_screenshot": getCheckedItems2('img') ? '1' : '0',
        "type_clip": getCheckedItems2('movie') ? '1' : '0',
        "type_checklist": getCheckedItems2('csv') ? '1' : '0'
      },
      { headers: { Authorization: jsonlist.token.IdToken } },
    )
      .then(res => {
        const DLurl = res.data;
        setSuccess(true);
        setLoading(1);
        console.log(DLurl)
        //console.log(Object.keys(del)[0]);
        /*
        for(let i in del) {
          //console.log(i);
          console.log(del[i]);
          for(let d in del[i]) {
            var DLurl = del[i][d][0];
          }
        }
        */
        //console.log(DLurl)
        window.open(DLurl, '_blank');

        handleClose()
      })
      .catch(error => {
        setSuccess(true);
        setLoading(1);
        console.log(error)
      })
      .finally(() => {
        closeLoading()
      })


  }

  // トースト表示
  const [toastOpenFlg, setToastOpen] = React.useState(false)
  const toastOpen = () => {
    setToastOpen(true);
  };

  const toastClose = () => {
    // if (reason === 'clickaway') {
    //   return;
    // }

    setToastOpen(false);
  };

  const action = (
    <React.Fragment>
      <IconButton
        size="small"
        aria-label="close"
        color="inherit"
        onClick={toastClose}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </React.Fragment>
  );

  const Btn_load = () => {
    if (loading == 0) {
      return [
        <Button
          style={{ width: "100px" }}
          variant="contained"
          onClick={clickSubmit}
          disabled
        >出力
        </Button>,
        <CircularProgress
          size={24}
          sx={{
            color: green[500],
            position: 'absolute',
            top: '50%',
            left: '50%',
            marginTop: '-12px',
            marginLeft: '-12px',
          }}
        />
      ];
    } else if (loading == 1) {
      return <Button
        style={{ color: "#fff", backgroundColor: "red", width: "100px" }}
        onClick={clickSubmit}
      >出力
      </Button>;
    } else if (loading == 2) {
      return <Button
        style={{ width: "100px" }}
        variant="contained"
        onClick={clickSubmit}
        disabled
      >出力
      </Button>;
    }
  }

  /*削除処理へ*/
  const del_date = (e: any) => {
    console.log(e)
    /*
          delCheckedItems(e);
          
          const del_list = []
          for(let i in e) {
            del_list.push(e[i].user_id)
            //console.log(users[i].user_name)
          }
          //console.log(del_list)
          
          delCheckedItems(del_list)
          handleClickOpen(); 
          */
  }
  /*削除処理へ*/

  return (
    <GenericTemplate title="検査結果 出力">
      <div>
        <Dialog
          open={open}
          TransitionComponent={Transition}
          keepMounted
          onClose={handleClose}
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogTitle style={{ color: "#0d47a1" }}>{"出力詳細選択"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-slide-description">
              出力したいデータを選択してください。<br />
              <Checkbox
                {...label}
                disabled
                id="movie"
                value="movie"
                onChange={clickCheck2}
                checked={getCheckedItems2("movie")}
              />動画(準備中)<br />
              <Checkbox
                {...label}
                id="img"
                value="img"
                onChange={clickCheck2}
                checked={getCheckedItems2("img")}
              />画像<br />
              <Checkbox
                {...label}
                id="csv"
                value="csv"
                onChange={clickCheck2}
                checked={getCheckedItems2("csv")}
              />チェックリスト

            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Box sx={{ m: 1, position: 'relative' }}>
                <Button
                  style={{ color: "#fff", backgroundColor: "#1e88e5" }}
                  onClick={handleClose}
                >キャンセル</Button>
              </Box>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Box sx={{ m: 1, position: 'relative' }}>
                {Btn_load()}
              </Box>
            </Box>
          </DialogActions>
        </Dialog>
      </div>

      <Snackbar
        open={toastOpenFlg}
        autoHideDuration={3000}
        onClose={toastClose}
        message="検査を選択してください。"
        action={action}
      />

      <Stack spacing={3} margin={2}></Stack>

      <Stack spacing={3} margin={1}></Stack>

      <TableContainer>
        <Table aria-label="simple table" className="table-list-style">
          <TableHead>
            <TableRow>
              <TableCell className="table-title"></TableCell>
              <TableCell className="table-title">検査作成日時</TableCell>
              <TableCell className="table-title">工種</TableCell>
              <TableCell className="table-title">種別</TableCell>
              <TableCell className="table-title">備考</TableCell>
              <TableCell className="table-title">立会者</TableCell>
              <TableCell className="table-title">土木使用共通仕様書番号</TableCell>
            </TableRow>
          </TableHead>
          <TableBody className="event_table">
            {(rowsPerPage > 0
              ? disprows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              : disprows
            ).map((row) => (
              <TableRow key={row.inspection_info_id}>
                <TableCell className="MuiTableCell-root2 center" component="th" scope="row">
                  <Checkbox
                    {...label}
                    id={row.inspection_info_id}
                    value={row.inspection_info_id}
                    onChange={clickCheck}
                    checked={getCheckedItems(row.inspection_info_id)}
                  />
                </TableCell>
                <TableCell className="MuiTableCell-root2" ><span>{row.created_at}</span></TableCell>
                <TableCell className="MuiTableCell-root2" ><span>{row.inspection_work_type}</span></TableCell>
                <TableCell className="MuiTableCell-root2" ><span>{row.inspection_kind}</span></TableCell>
                <TableCell className="MuiTableCell-root2" ><span>{row.remarks}</span></TableCell>
                <TableCell className="MuiTableCell-root2" ><span>{row.witness}</span></TableCell>
                <TableCell className="MuiTableCell-root2" ><span>{row.common_number}</span></TableCell>
                {/*
                  <TableCell className="MuiTableCell-root2" ><Link to={{pathname: "/UserDetail", state: {id: row.user_id,comid: row.company_id, user_name:row.user_name, user_name_kana:row.user_name_kana, authority_code:row.authority_code, remarks:row.remarks}}}>{row.address}</Link></TableCell>
                  <TableCell className="MuiTableCell-root2" ><Link to={{pathname: "/UserDetail", state: {id: row.user_id,comid: row.company_id, user_name:row.user_name, user_name_kana:row.user_name_kana, authority_code:row.authority_code, remarks:row.remarks}}}>{row.address}</Link></TableCell>
                  <TableCell className="MuiTableCell-root2" ><Link to={{pathname: "/UserDetail", state: {id: row.user_id,comid: row.company_id, user_name:row.user_name, user_name_kana:row.user_name_kana, authority_code:row.authority_code, remarks:row.remarks}}}>{AUTHORITY[row.authority_code]}</Link></TableCell>
                  <TableCell className="MuiTableCell-root2" ><Link to={{pathname: "/UserDetail", state: {id: row.user_id,comid: row.company_id, user_name:row.user_name, user_name_kana:row.user_name_kana, authority_code:row.authority_code, remarks:row.remarks}}}>{row.last_login_at}</Link></TableCell>
                  <TableCell className="MuiTableCell-root2" ><Link to={{pathname: "/UserDetail", state: {id: row.user_id,comid: row.company_id, user_name:row.user_name, user_name_kana:row.user_name_kana, authority_code:row.authority_code, remarks:row.remarks}}}>{row.remarks}</Link></TableCell>
              */}
              </TableRow>
            ))}
          </TableBody>
          <TableFooter>
            <TableRow>
              <TablePagination
                labelRowsPerPage="表示件数:"
                rowsPerPageOptions={[
                  { label: '5件', value: 5 },
                  { label: '10件', value: 10 },
                  { label: '25件', value: 25 },
                  { label: '全て', value: -1 }
                ]}
                colSpan={7}
                count={postslist.length}
                rowsPerPage={rowsPerPage}
                page={page}
                SelectProps={{
                  inputProps: {
                    'aria-label': 'rows per page',
                  },
                  native: true,
                }}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                ActionsComponent={TablePaginationActions}
                className="table-footer"
              />
            </TableRow>
          </TableFooter>
        </Table>
      </TableContainer>
      <Stack spacing={3} margin={1}></Stack>

      {/*
      <ThemeProvider theme={theme}>
      <MaterialTable
        options={{
          search: true,
          draggable: true,
          filtering: true,
          selection: true,
          headerStyle: {
            backgroundColor: '#ececec',
            color: '#000'
          },
        }}
        actions={[
          {
            tooltip: '選択したユーザーを削除する',
            icon: 'delete',
            onClick: (evt, data) => del_date(data)
          }
        ]}
        columns={[

          { 
            title: '日時', 
            field: 'created_at',
          },
          {
            title: '工種',
            field: 'inspection_work_type',
          },
          {
            title: '種別',
            field: 'inspection_kind',
          },
          {
            title: '備考',
            field: 'remarks',
          },
          {
            title: '立会者',
            field: 'witness',
          },
          {
            title: '土木使用共通番号',
            field: 'common_number',
          },
        ]}
        data={rows}
        title="ユーザーリスト"
        localization={localizationJapanese}
      />
</ThemeProvider>
      */}

      <Stack spacing={0} margin={0}>
        <Grid container spacing={0}>
          <Grid item xs={1}>
            <Button
              className="btnlink"
              color="primary"
              variant="contained"
              size="large"
              component={Link}
              to={{ pathname: "/Inspectionlist", state: { conid: conid } }}
            >
              戻る
            </Button>
          </Grid>
          <Grid item xs={1}>
            <Button
              style={{ color: "#fff", backgroundColor: "#FFA500" }}
              variant="contained"
              size="large"
              onClick={DelCheckSubmit}
            >
              出力
            </Button>
          </Grid>
        </Grid>
      </Stack>
    </GenericTemplate>
  );
};

export default Constructionlist;